import React from 'react'
import styled from 'styled-components'
import { colors } from 'styles'
import { connect } from 'react-redux'

export const StyledCopyright = styled.p`
  display: inline-flex;
  font-size: 1.2rem;
  color: ${colors.textSecondary};
  opacity: 0.7;
`

const Copyright = ({ siteName }) => (
  <StyledCopyright>
    &copy; {siteName} {new Date().getFullYear()}
  </StyledCopyright>
)

export default connect(({ siteConfig }) => siteConfig)(Copyright)
